import { CSSProperties } from "@mui/styles";

export const ellipses: CSSProperties = {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
};
